// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$("input[name=_url_source]").val(document.URL);
	$(document).ready(function () {
		
	});

	$("input[name*=i_d_like_to_receive_information_about_]").on("change", function(){
		switch($(this).val()){
			case "Home Ownership":        
				$("input[name=_list_id]").val("W9uW8B");
				break;
			case "Investment Opportunities":        
				$("input[name=_list_id]").val("YjDmfT");
				break;
			case "Marina":        
				$("input[name=_list_id]").val("SYXWVj");
				break;    
		}
	})

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		document.querySelector(".scroll-js").addEventListener('click', function(e){
			e.preventDefault();
			animateTo(this.getAttribute('href').split('#')[1]);
		});

		if(document.getElementById('home')){
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			});
		} else {
			document.getElementById('header').classList.add('down');
		}

		scrollAnimate();
		window.addEventListener('scroll', function(){
			scrollAnimate();
		});
		if($(window).width() < 990) {
			$('.glance__list').slick({
				arrows:false,
				dots:true
			});
		}
	};

}());


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

}

function scrollAnimate(){

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1500; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
